export const Product = {
    path: '/products',
    name: 'products',
    component: () => import('@/views/Product/ProductPage.vue'),
    children: [
        {
            path: '/products/add',
            name: 'products.add',
            component: () => import('@/views/Product/Form/ProductForm.vue'),
            props: {addAction: true},
        },
        {
            path: '/products/edit/:id',
            name: 'products.edit',
            component: () => import('@/views/Product/Form/ProductForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/products/delete/:id',
            name: 'products.delete',
            component: () => import('@/views/Product/Form/ProductForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/products/view/:id',
            name: 'products.view',
            component: () => import('@/views/Product/Form/ProductForm.vue'),
            props: {viewAction: true}
        },
    ]
}